import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  templateId: string;
}

export const useGenerateProformaB2BInvoice = () => {
  return useMutation({
    mutationFn: async ({ batchId, templateId }: HookProps) => {
      const result = await apiClient.batchesReports.generateProformaB2bInvoice.mutation({ body: { batchId, templateId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      toast.success('Proforma B2B Invoice generation started!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating Proforma B2B Invoice!');
    },
  });
};
